<template>
    <header class="header">
        <div class="container">
            <div class="row align-items--center">
                <div v-if="backUrl" class="col-2">
                    <router-link :to="backUrl" class="btn btn--icon btn--white">
                        <i class="material-icons">keyboard_arrow_left</i>
                    </router-link>
                </div>

                <div class="col-8" :class="{'offset-2': ! backUrl}">
                    <h1 class="header__title">{{ title }}</h1>
                </div>

                <div class="col-2 text--right">
                    <router-link v-if="closeable && redirectOnClose" :to="redirectOnClose === null ? '/' : redirectOnClose" class="btn btn--icon btn--white">
                        <i class="material-icons">close</i>
                    </router-link>
                    <a v-else-if="closeable" @click.prevent="handleBack('/')"class="btn btn--icon btn--white">
                        <i class="material-icons">close</i>
                    </a>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import internalBackRoute from "../../mixins/internalBackRoute";

    export default {
        mixins: [internalBackRoute],
        props: {
            backUrl: {
                required: false,
                default: false,
            },

            closeable: {
                required: false,
                default: false,
            },

            redirectOnClose: {
                required: false,
                default: null,
            },

            title: {
                required: false,
                default: '',
            }
        }
    }
</script>